import { render, staticRenderFns } from "./World.vue?vue&type=template&id=c343bb7c&scoped=true"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"
import style0 from "./World.vue?vue&type=style&index=0&id=c343bb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c343bb7c",
  null
  
)

export default component.exports